import { renderCopyHover } from 'helpers';
import { TFunc } from 'libs/i18n';
import { AdminsListItem } from 'modules/admin/admins/types';

export const renderRole = (item: AdminsListItem, t: TFunc) => {
  if (!item.role) return null;

  const text = t(`admin.adminRoles.${item.role?.name}`);

  return renderCopyHover(text);
};
